import { render, staticRenderFns } from "./WithSideNavigations.vue?vue&type=template&id=80868566&scoped=true"
import script from "./WithSideNavigations.vue?vue&type=script&lang=js"
export * from "./WithSideNavigations.vue?vue&type=script&lang=js"
import style0 from "./WithSideNavigations.vue?vue&type=style&index=0&id=80868566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80868566",
  null
  
)

export default component.exports